import _ from 'lodash';
import timm from 'timm';

import { Types as PurchasesTypes }   from 'app/actions/company-admin/company-purchases';
import utils                         from 'app/reducers/utils';

const initialState = {};

const reducer = utils.createReducer(initialState, {

  ...utils.entityHandlers(['gift', 'gifts']),

  [`${PurchasesTypes.GET}_RESOLVED`]: (state, {result: {gifts}}) => {
    return timm.mergeDeep(state, utils.idMap(gifts));
  },

});

export default reducer;
